module.exports = __webpack_public_path__ + "img/about_back.c91f10e6.png";